export const ContentMessageTypes = ['info', 'message', 'refresh'] as const;
export type ContentMessageType = (typeof ContentMessageTypes)[number];

export enum FeedbackType {
  TEACHER_FEEDBACK = 'TEACHER_FEEDBACK',
  ASSIGNMENT_DELETION = 'ASSIGNMENT_DELETION',
  SEQUENCE_DELETION = 'SEQUENCE_DELETION',
}

export interface QuestionFeedback {
  id: string;
  createdAt: string;
  header: string;
  message: string;
  type: FeedbackType;
  contentMessageType: ContentMessageType;
}
